export default {
  'fetch': () => import('isomorphic-fetch'),
  'Object.assign': () => import('../polyfill-service/object-assign'),
  'Array.prototype.includes': () => import('../polyfill-service/array-includes'),
  'String.prototype.includes': () => import('../polyfill-service/string-includes'),
  'IntersectionObserver': ()=> import('../polyfill-service/IntersectionObserver'),
  'Proxy': ()=> import('../polyfill-service/proxy'),
  'URLSearchParams': ()=> import('../polyfill-service/url-search-params')
};



// WEBPACK FOOTER //
// ./config/polyfills.js